import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/TravelExpenseHome.html?raw';
import TravelExpenseTable from './TravelExpenseTable';
import TravelExpenseList from '../Main/TravelExpenseList';
import dojoDate from 'dojo/date/locale';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo dep (_base/connect). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class TravelExpenseHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    _table: any = null;
    mode = "projectCostEntry"; //"webform"
    _filterSettings: any = null;
    _currentFilterSettings: any = null;
    _filterSettingsForProject: any = null;
    entitylist: any = null;
    projectlist: any = [];
    selectedStatus: any = [];
    selectedTypes: any = [];
    dirty = false;

    loadFilterOptions(): void {
        this.StandbyStart();

        this.showError(false);

        var url = window.appRoot + "SOV/TravelExpensesGetFilterOptions";

        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError),
            false // sync
        );
    }

    _onLoadFilterOptionsResponse(response: any): void {
        domConstruct.empty(this.statusinputContainer);

        this.StandbyStop();

        let data = JSON.parse(response);

        // Checkboxen für Status bauen
        this.selectedStatus = [];
        if (data.statuslist && data.statuslist.length) {
            for (let i = 0; i < data.statuslist.length; i++) {
                let status = data.statuslist[i];

                let outerDiv = domConstruct.create("div", {}, this.statusinputContainer);

                let cb = domConstruct.create("input", {
                    "type": "checkbox",
                    "checked": "checked",
                    "id": "cb-" + status.ID
                }, outerDiv);

                this.selectedStatus.push(status.ID);

                on(cb, "change", lang.hitch(this, this._onChange_cbStatus, status.ID, cb));

                let label = domConstruct.create("label", {
                    "innerHTML": status.description,
                    "for": "cb-" + status.ID
                }, outerDiv);
            }
        }

        // Checkboxen für die Kostenarten bauen
        this.selectedTypes = [];
        if (data.typeslist && data.typeslist.length) {
            for (let i = 0; i < data.typeslist.length; i++) {
                let type = data.typeslist[i];

                let outerDiv = domConstruct.create("div", { class: "paddingSmall" }, this.typesinputContainer);

                let cb = domConstruct.create("input", {
                    "type": "checkbox",
                    "checked": "checked",
                    "id": "cb-" + type.ID
                }, outerDiv);

                this.selectedTypes.push(type.ID);

                on(cb, "change", lang.hitch(this, this._onChange_cbType, type.ID, cb));

                let label = domConstruct.create("label", {
                    "innerHTML": type.description,
                    "for": "cb-" + type.ID
                }, outerDiv);
            }
        }
        //this.serializeFilterData();
        this._onChange_Mode();
    }

    _onLoadFilterOptionsError(error: any): void {
        this.StandbyStop();

        //alert(error.Message);
        this.showError(error.Message);

        console.error("_onLoadFilterOptionsError", error);
    }

    _checkProjectSelect(): void {

        this.projectSelectInput.value = "";
        domClass.add(this.projectSelectContainer, "w3-hide");
        domClass.remove(this.projectSelectFilterInfo, "w3-hide");
        domClass.add(this.projectSelectFilterNoResults, "w3-hide");
        this.btnSubmit.innerHTML = "Filtern";

        if (this._filterSettings !== null) {
            let _filSet = JSON.parse(this._filterSettings);

            if (this.projectlist.length > 0) {
                if (_filSet.projectId === "" && !this.dirty) {
                    domClass.remove(this.projectSelectContainer, "w3-hide");
                    domClass.add(this.projectSelectFilterInfo, "w3-hide");
                    this.btnSubmit.innerHTML = "Filtern mit Projekt";
                }
            } else {
                if (_filSet.projectId === "" && !this.dirty) {
                    domClass.add(this.projectSelectFilterInfo, "w3-hide");
                    domClass.remove(this.projectSelectFilterNoResults, "w3-hide");
                }
            }
        }

        //    let _filSet = this._filterSettings
        //    if (this._filterSettings !== null && JSON.parse(this._filterSettings).projectId === "") {
        //        domClass.remove(this.projectSelectContainer, "w3-hide");
        //        domClass.add(this.projectSelectFilterInfo, "w3-hide");
        //        this.btnSubmit.innerHTML = "Filtern mit Projekt";
        //    }
    }

    _onChange_InputStart(evt: any): void {
        //evt.stopPropagation();
        console.debug("_onChange_InputStart", this.inputDateStart.value);
        this.serializeFilterData();
        this._checkProjectSelect();
    }

    _onChange_InputEnd(evt: any): void {
        //evt.stopPropagation();
        this.serializeFilterData();
        this._checkProjectSelect();
    }

    _onChange_Mode(): void {
        this.mode = this.inputMode.value;
        this.serializeFilterData();

        if (this.inputMode.value == "projectCostEntry") {
            domClass.add(this.statusCheckboxes, "w3-hide");
            domClass.remove(this.typesCheckboxes, "w3-hide");
        }
        else if (this.inputMode.value == "webform") {
            domClass.remove(this.statusCheckboxes, "w3-hide");
            domClass.add(this.typesCheckboxes, "w3-hide");
        }
    }

    _onChange_ProjectSelect(): void {
        if (this.projectSelectInput.value !== "") {
            this.btnSubmit.innerHTML = "Filtern mit Projekt";
        } else {
            this.btnSubmit.innerHTML = "Filtern";
        }
        this.serializeFilterData();
    }

    _onChange_cbStatus(statusID: any, checkbox: any, evt?: any): void {

        let index = this.selectedStatus.indexOf(statusID, 0);
        if (index != -1) {
            this.selectedStatus.splice(index, 1);
        }

        if (checkbox.checked) {
            this.selectedStatus.push(statusID);
        }

        this.selectedStatus.sort();
        //console.debug("_onChange_cbStatus", statusID, this.selectedStatus, checkbox);

        this.serializeFilterData();
        this._checkProjectSelect();
    }

    _onChange_cbType(typeID: any, checkbox: any, evt?: any): void {

        let index = this.selectedTypes.indexOf(typeID, 0);
        if (index != -1) {
            this.selectedTypes.splice(index, 1);
        }

        if (checkbox.checked) {
            this.selectedTypes.push(typeID);
        }

        this.selectedTypes.sort();
        //console.debug("_onChange_cbType", typeID, this.selectedTypes, checkbox);

        this.serializeFilterData();
        this._checkProjectSelect();
    }


    serializeFilterData(): void {
        if (this.dateValidation() == true) {
            var currentSettings = {
                dateStart: this.inputDateStart.value,
                dateEnd: this.inputDateEnd.value,
                mode: this.mode,
                projectId: this.projectSelectInput.value,
                statuslist: this.selectedStatus,
                typeslist: this.selectedTypes
            };

            this._currentFilterSettings = JSON.stringify(currentSettings);

            this.setDirty(this._filterSettings != this._currentFilterSettings);

            //console.debug("serializeFilterData f:", this._filterSettings, "serializeFilterData c:", this._currentFilterSettings);
        }
    }

    dateValidation(bool?: any): any {
        if (isNaN(Date.parse(this.inputDateStart.value)) || isNaN(Date.parse(this.inputDateEnd.value))) {
            domClass.remove(this.btnSubmit, "mds-orange mds-hover-bright");
            domClass.add(this.btnSubmit, "w3-disabled");

            if (isNaN(Date.parse(this.inputDateStart.value))) {
                domClass.add(this.inputDateStart, "w3-pale-red w3-text-red w3-border w3-border-red");
            } else {
                domClass.remove(this.inputDateStart, "w3-pale-red w3-text-red w3-border w3-border-red");
            }

            if (isNaN(Date.parse(this.inputDateEnd.value))) {
                domClass.add(this.inputDateEnd, "w3-pale-red w3-text-red w3-border w3-border-red");
            } else {
                domClass.remove(this.inputDateEnd, "w3-pale-red w3-text-red w3-border w3-border-red");
            }

            domClass.remove(this.errorMessageNode, "w3-hide");
            this.errorMessageNode.innerHTML = "Ungültiges Datum";

            return false;
        }
        else {
            if (Date.parse(this.inputDateStart.value) > Date.parse(this.inputDateEnd.value)) {
                domClass.remove(this.btnSubmit, "mds-orange mds-hover-bright");
                domClass.add(this.btnSubmit, "w3-disabled");

                domClass.remove(this.errorMessageNode, "w3-hide");
                this.errorMessageNode.innerHTML = "Ungültiger Zeitraum ";

                return true;
            } else {
                domClass.add(this.btnSubmit, "mds-orange mds-hover-bright");
                domClass.remove(this.btnSubmit, "w3-disabled");

                domClass.remove(this.inputDateStart, "w3-pale-red w3-text-red w3-border w3-border-red");
                domClass.remove(this.inputDateEnd, "w3-pale-red w3-text-red w3-border w3-border-red");

                domClass.add(this.errorMessageNode, "w3-hide");

                return true;
            }
        }
    }

    setDirty(bool: any): void {
        this.dirty = bool !== false;
        console.debug("dirty", this.dirty);


        if (this.dirty) {
            domClass.add(this.btnSubmit, "mds-orange mds-hover-bright");
            domClass.remove(this.btnSubmit, "w3-disabled");
            domClass.add(this.tableContainer, "w3-disabled");
            domClass.add(this.btnDownloadTravelExpenseReport, "w3-hide");
        } else {
            domClass.remove(this.btnSubmit, "mds-orange mds-hover-bright");
            domClass.remove(this.tableContainer, "w3-disabled");
            domClass.remove(this.btnDownloadTravelExpenseReport, "w3-hide");
        }
    }

    _onClick_Submit(evt: any): void {

        if (!this.dirty) {
            return;
        }

        this.getFilterData();
    }

    getFilterData(): void {

        this.StandbyStart();

        var url = window.appRoot + "SOV/TravelExpensesGetList";

        this.RequestManager.post(
            url,
            {
                "jsonData": this._currentFilterSettings
            },
            lang.hitch(this, this._onGetFilterDataResponse),
            lang.hitch(this, this._onGetFilterDataError),
            false // sync
        );


    }

    _onGetFilterDataResponse(response: any): void {
        this.StandbyStop();

        this._filterSettings = this._currentFilterSettings;
        this.setDirty(false);
        domClass.add(this.errorMessageNode, "w3-hide");
        domConstruct.place(this.noResults, this.hiddenNode);

        this.entitylist = JSON.parse(response);

        console.log("getFilterlistResponse", this.entitylist);

        this.projectlist = [];

        for (let entry of this.entitylist) {
            if (entry.ref_orchestra_employment) {
                let proj = entry.ref_orchestra_employment.ref_ev_booking.ref_ev_project;
                if (this.projectlist.filter((p: any) => p.ID === proj.ID) == 0) {
                    this.projectlist.push(proj);
                }
            }
            else if (entry.ref_musican_planning_ev_project) {
                let proj = entry.ref_musican_planning_ev_project.ref_ev_project;
                if (this.projectlist.filter((p: any) => p.ID === proj.ID) == 0) {
                    this.projectlist.push(proj);
                }
            }
        }

        if (this._table != null) {
            this._table.destroy();
            this._table = null;
        }

        if (!this.entitylist || !this.entitylist.length) {
            domConstruct.empty(this.tableContainer);
            domConstruct.place(this.noResults, this.tableContainer);
        } else {
            if (this.mode == "webform") {
                this._table = new TravelExpenseList();

                this._table.set("buttons", false);
                this._table.set("sumrow", true);

                this._table.set("data", this.entitylist);


            } else if (this.mode == "projectCostEntry") {
                this._table = new TravelExpenseTable();
                this._table.set("data", this.entitylist);
            } else {
                this.showError("wrong mode?!");
                return;
            }
        }


        if (this.projectlist.length > 0) {
            this._buildProjectSelect();
            domClass.add(this.projectSelectFilterNoResults, "w3-hide");
            domClass.remove(this.btnDownloadTravelExpenseReport, "w3-disabled");

        } else {
            domClass.remove(this.projectSelectFilterNoResults, "w3-hide");
            domClass.add(this.projectSelectFilterInfo, "w3-hide");
            domClass.add(this.btnDownloadTravelExpenseReport, "w3-disabled");
        }




        if (this._table != null) {
            domConstruct.place(this._table.domNode, this.tableContainer);
            domClass.remove(this.tableContainer, "w3-disabled");

            domClass.remove(this.btnDownloadTravelExpenseReport, "w3-hide");
        }

    }

    _buildProjectSelect(): void {
        domClass.remove(this.projectSelectContainer, "w3-hide");
        domClass.add(this.projectSelectFilterInfo, "w3-hide");

        //console.debug(this.projectSelectInput.value);
        if (this.projectSelectInput.value === "") {
            domConstruct.empty(this.projectSelectInput);

            let select = this.projectSelectInput;

            let emptyOpt = domConstruct.create("option", {
                "value": "",
                "id": "select-empty",
                "innerHTML": "= Kein Projekt gewählt ="
            }, select);

            for (var i = 0; i < this.projectlist.length; i++) {
                let proj = this.projectlist[i];

                let option = domConstruct.create("option", {
                    "value": proj.ID,
                    "id": "select-" + proj.ID,
                    "innerHTML": proj.gDisp_1
                }, select);
            }
        }
    }

    _onGetFilterDataError(error: any): void {
        this.StandbyStop();

        if (this._table != null) {
            this._table.destroy();
            this._table = null;
        }

        domClass.remove(this.btnSubmit, "w3-disabled");

        //alert(error.Message);
        this.showError(error.Message);

        console.error("_onGetFilterDataError", error);
    }

    _onClick_DownloadTravelExpenseReport(evt: any): void {
        if (this.projectlist && !this.dirty) {
            if (this.projectlist.length == 0) {
                return;
            }
        } else {
            return;
        }
        this.downloadTravelExpenseReport();
    }

    downloadTravelExpenseReport(): void {

        var url = window.appRoot + "SOV/TravelExpensesCreateReport";

        this.StandbyStart(this.btnDownloadTravelExpenseReport);
        domClass.add(this.btnDownloadTravelExpenseReport, "w3-disabled");

        (window as any).encodeURIComponent() // JS2TS: original calls encodeURIComponent() with no argument (no-op bug) — preserved

        this.RequestManager.post(
            url,
            {
                "filteredList": JSON.stringify(this.entitylist),
                "filterParams": this._filterSettings
            },
            lang.hitch(this, this._onCreateReportResponse),
            lang.hitch(this, this._onCreateReportReportError),
            false // sync
        );
    }

    _onCreateReportResponse(response: any): void {
        this.StandbyStop();
        domClass.remove(this.btnDownloadTravelExpenseReport, "w3-disabled");
        var guid = JSON.parse(response).guid;
        var url = window.appRoot + "SOV/TravelExpensesDownloadReport?guid=" + guid;
        window.open(url);
    }

    _onCreateReportReportError(error: any): void {
        alert(error);
        domClass.remove(this.btnDownloadTravelExpenseReport, "w3-disabled");
        this.StandbyStop();
    }


    showError(message: any): void {
        if (message == null || message == "" || typeof (message) == "undefined" || message == false) {
            domClass.add(this.errorMessageNode, "w3-hide");
            return;
        }

        this.errorMessageNode.innerHTML = message;
        domClass.remove(this.errorMessageNode, "w3-hide");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.loadFilterOptions();

        this.inputMode.value = this.mode;

        // Datum setzen
        let dateFormat_ddMMyyyy_HHmm: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        let dateFormat_HHmm: any = { hour: '2-digit', minute: '2-digit' };
        let dateFormat_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit'/*, hour: '2-digit', minute: '2-digit'*/ };
        let dateFormat_yyyyMMdd: any = { selector: "date", datePattern: "yyyy-MM-dd" };
        let dateFormat_dddd_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long'/*, hour: '2-digit', minute: '2-digit'*/ };

        let date = new Date();//dojoDate.parse(value, { datePattern: "yyyy-MM-dd", selector: "date" });

        let nowTxt = dojoDate.format(date, dateFormat_yyyyMMdd);
        this.inputDateEnd.value = nowTxt;

        date.setDate(1);
        date.setFullYear(date.getFullYear() - 1);
        nowTxt = dojoDate.format(date, dateFormat_yyyyMMdd);
        this.inputDateStart.value = nowTxt;

        console.debug("dateformat now", nowTxt);

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
TravelExpenseHome.prototype.declaredClass = 'WidgetCollection.SOV.legacy.TravelExpenses.TravelExpenseHome';

export default mdsWidget(TravelExpenseHome);
